import { Meeting } from '../../models/chat';
import { ChatService } from '../../ng-services/chat.service';

(function () {
    class ChatMeetingsNavbarDropdownComponent {
        static $inject = ['ChatService', '$timeout', '$filter', '$scope'];

        private meetings: Meeting[] = [];

        private subscribes!: Rx.IDisposable[];

        constructor(
            private chatService: ChatService,
            private $timeout: angular.ITimeoutService,
            private $filter: angular.IFilterService,
            private $scope: angular.IScope
        ) {}

        $onInit() {
            this.subscribes = [
                this.chatService
                    .getMeetings$()
                    .map((meetings: Meeting[]) =>
                        this.$filter('orderBy')(meetings, [
                            (meeting: Meeting) => (meeting.id === 0 ? -1 : 0),
                            '!newMessageCount',
                            '!lastMessageDate',
                            '-lastMessageDate',
                        ])
                    )
                    .subscribe((meetings) => {
                        this.$scope.$evalAsync(() => {
                            this.meetings = meetings;
                        });
                    }),
            ];
        }

        $onDestroy() {
            this.subscribes.forEach((d) => d.dispose());
        }

        meetingUrl(meeting: Meeting) {
            return `/meeting/${meeting.id}`;
        }
    }

    angular.module('tradersyard').component('tyChatMeetingsNavbarDropdown', {
        // language=HTML
        template: `
            <div class="dropdown">
                <div class="meetings" id="meeting-container">

                    <div class="message" ng-if="$ctrl.meetings.length === 0">
                        You don't have any conversations
                    </div>

                    <div id="topbar-meeting-container" class="content scrollable">
                        <div>
                            <div class="item" ng-repeat="meeting in $ctrl.meetings">
                                <div class="meeting-header">
                                    <div class="meeting-user">
                                        <a ng-href="{{$ctrl.meetingUrl(meeting)}}">
                                            <img ng-src="{{::meeting.thumbnail_url|thumb:80:80}}" alt="">
                                        </a>
                                    </div>

                                    <a class="meeting-info" ng-href="{{$ctrl.meetingUrl(meeting)}}">
                                        <div class="name">
                                            <span ng-bind="meeting.name"></span>
                                            <span ng-show="meeting.newMessageCount > 0" class="unread item"></span>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="show more ng-scope" ng-if="$ctrl.meetings.length > 0">
                        <a ng-href="/meetings" href="/meetings">Show all conversations</a>
                    </div>
                </div>
            </div>
        `,
        bindings: {},
        controller: ChatMeetingsNavbarDropdownComponent,
    });
})();
